module.exports = __webpack_public_path__ + "img/v-kyc-icon.38343637.svg";